import React, { Fragment } from 'react';

function PageTitle(props) {
  
  return (
    <Fragment>
      
    </Fragment>
  );
}

export default PageTitle;
